<template>
  <va-modal
    id="appointment-files-upload-modal"
    ref="appointmentFilesUploadModal"
    :value="isOpen"
    :okText="$t('modals.buttons.confirm')"
    :okClass="'btn btn-primary btn-micro'"
    :okToClose="false"
    :okDisabled="!form.file || isSubmitting"
    @ok="submit"
    :cancelText="$t('modals.buttons.back')"
    :cancelClass="'btn-cancelar btn btn-primary btn-micro'"
    @cancel="onCancel"
    :large="true"
  >

    <div slot="header" class="modal-title">
      {{ isUpdate ? `${$t('homelab.files.update_modal_title')} - ${file.name}` : $t('homelab.files.upload_modal_title') }}
    </div>

    <form class="py-4 evollu-form">
      <div class="justify-content-center col-12">
        <div class="justify-content-center text-center col-12" @click="uploadFile">
          <span class="clickable">
            <span class="upload_input">{{$t('homelab.files.choose_upload_file')}}</span> &ensp; <i class="fa fa-upload"/>
          </span>
        </div>
        <br/>
        <div class="d-flex justify-content-center col-12" v-if="!form.file">
          <input ref="uploadFilesInput" id="upload-file-input" type="file" @input="onFileSelected" hidden accept=".pdf" >
        </div>
        <div class="d-flex justify-content-start align-items-center col-12" v-else>
          <span class="font-weight-bold">{{form.file.name}}</span>
          <i class="fa fa-times ml-1 clickable" @click.prevent="removeFile"></i>
        </div>
        <small v-if="form.errors.has('file')" class="help text-danger">
          {{$t(form.errors.get('file'))}}
        </small>
      </div>
    </form>

    <LoadingPlaceholder v-if="isLoading" />

  </va-modal>
</template>
<script>
import { mapState } from 'vuex'
import Errors from '@/utils/CustomNodeErrors.js'
import { AppointmentFilesService } from '@/api/HomelabService'
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder'

export default {
  props: {
    appointment: {
      type: Object,
      required: true,
    },
    file: {
      type: Object,
      required: false
    },
    fileType: {
      type: Number,
      required: true
    }
  },
  components: {
    LoadingPlaceholder
  },
  computed: {
    ...mapState('homelab', [
      'appointmentFileTypes'
    ]),
    isUpdate: function () {
      return this.file !== null && this.file !== undefined && this.file !== ''
    }
  },
  data () {
    return {
      isSubmitting: false,
      isOpen: false,
      isLoading: false,
      form: {
        file: null,
        errors: new Errors()
      },
      allowedExtensions: ['pdf'],
    }
  },
  mounted () {
    this.isOpen = true
  },
  methods: {
    submit: function () {
      this.isSubmitting = true
      let formData = new FormData()
      formData.append('file', this.form.file)
      let promiseToExecute
      formData.append('file_type_id', this.fileType)
      if (this.isUpdate) {
        formData.append('_method', 'PUT')
        promiseToExecute = AppointmentFilesService.update(this.appointment.id, this.file.id, formData)
      } else {
        // For now, all files that are created through this UI are Result files
        promiseToExecute = AppointmentFilesService.store(this.appointment.id, formData)
      }

      promiseToExecute
        .then(file => {
          this.showToast(this.isUpdate ? this.$t('homelab.files.file_updated') : this.$t('homelab.files.file_submitted'), this.$store.state.successToastOptions)
          this.$emit('file-uploaded', { file })
          this.isSubmitting = false
          setTimeout(this.onCancel, 250)
        })
        .catch(errors => {
          if (errors.response && errors.response.status === 419) {
            this.isSubmitting = false
            this.showToast(this.$t('homelab.files.file_too_long'), this.$store.state.errorToastOptions)
          } else if (errors.response.status === 403) {
            this.isSubmitting = false
            this.showToast(this.$t('homelab.files.missing_store_permissions', this.$store.state.errorToastOptions))
          } else {
            this.isSubmitting = false
            this.showToast(this.$t('homelab.files.something_went_wrong'), this.$store.state.errorToastOptions)
          }
        })
    },
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('cancel')
      }, 500)
    },
    onFileSelected: function (event) {
      let files = event.target.files || event.dataTransfer.files
      if (!files.length) {
        return
      }
      this.form.file = files[0]
    },
    uploadFile: function () {
      this.$refs.uploadFilesInput.click()
    },
    removeFile: function () {
      this.form.file = null
    },
  }
}
</script>

<style lang='scss'>
  .upload_input {
    &:hover {
      text-decoration: underline;
    }
  }
</style>
